import { __decorate, __metadata } from "tslib";
import { ContextService, RenderingPluginContribution } from '@antv/g';
import { inject, singleton } from 'mana-syringe';
import { supportsPointerEvents, supportsTouchEvents } from './utils';
/**
 * listen to mouse/touch/pointer events on DOM wrapper, trigger pointer events
 */

var DOMInteractionPlugin =
/** @class */
function () {
  function DOMInteractionPlugin() {}

  DOMInteractionPlugin_1 = DOMInteractionPlugin;

  DOMInteractionPlugin.prototype.apply = function (renderingService) {
    var _this = this;

    var onPointerMove = function onPointerMove(ev) {
      renderingService.hooks.pointerMove.call(ev);
    };

    var onPointerUp = function onPointerUp(ev) {
      renderingService.hooks.pointerUp.call(ev);
    };

    var onPointerDown = function onPointerDown(ev) {
      renderingService.hooks.pointerDown.call(ev);
    };

    var onPointerOver = function onPointerOver(ev) {
      renderingService.hooks.pointerOver.call(ev);
    };

    var onPointerOut = function onPointerOut(ev) {
      renderingService.hooks.pointerOut.call(ev);
    };

    var onPointerWheel = function onPointerWheel(ev) {
      renderingService.hooks.pointerWheel.call(ev);
    };

    renderingService.hooks.init.tap(DOMInteractionPlugin_1.tag, function () {
      var $el = _this.contextService.getDomElement();

      if (supportsPointerEvents) {
        self.document.addEventListener('pointermove', onPointerMove, true);
        $el.addEventListener('pointerdown', onPointerDown, true);
        $el.addEventListener('pointerleave', onPointerOut, true);
        $el.addEventListener('pointerover', onPointerOver, true);
        self.addEventListener('pointerup', onPointerUp, true);
      } else {
        self.document.addEventListener('mousemove', onPointerMove, true);
        $el.addEventListener('mousedown', onPointerDown, true);
        $el.addEventListener('mouseout', onPointerOut, true);
        $el.addEventListener('mouseover', onPointerOver, true);
        self.addEventListener('mouseup', onPointerUp, true);
      } // always look directly for touch events so that we can provide original data
      // In a future version we should change this to being just a fallback and rely solely on
      // PointerEvents whenever available


      if (supportsTouchEvents) {
        $el.addEventListener('touchstart', onPointerDown, true);
        $el.addEventListener('touchend', onPointerUp, true);
        $el.addEventListener('touchmove', onPointerMove, true);
      } // use passive event listeners
      // @see https://zhuanlan.zhihu.com/p/24555031


      $el.addEventListener('wheel', onPointerWheel, {
        passive: true,
        capture: true
      });
    });
    renderingService.hooks.destroy.tap(DOMInteractionPlugin_1.tag, function () {
      var $el = _this.contextService.getDomElement();

      if (supportsPointerEvents) {
        self.document.removeEventListener('pointermove', onPointerMove, true);
        $el.removeEventListener('pointerdown', onPointerDown, true);
        $el.removeEventListener('pointerleave', onPointerOut, true);
        $el.removeEventListener('pointerover', onPointerOver, true);
        self.removeEventListener('pointerup', onPointerUp, true);
      } else {
        self.document.removeEventListener('mousemove', onPointerMove, true);
        $el.removeEventListener('mousedown', onPointerDown, true);
        $el.removeEventListener('mouseout', onPointerOut, true);
        $el.removeEventListener('mouseover', onPointerOver, true);
        self.removeEventListener('mouseup', onPointerUp, true);
      }

      if (supportsTouchEvents) {
        $el.removeEventListener('touchstart', onPointerDown, true);
        $el.removeEventListener('touchend', onPointerUp, true);
        $el.removeEventListener('touchmove', onPointerMove, true);
      }

      $el.removeEventListener('wheel', onPointerWheel, true);
    });
  };

  var DOMInteractionPlugin_1;
  DOMInteractionPlugin.tag = 'DOMInteractionPlugin';

  __decorate([inject(ContextService), __metadata("design:type", Object)], DOMInteractionPlugin.prototype, "contextService", void 0);

  DOMInteractionPlugin = DOMInteractionPlugin_1 = __decorate([singleton({
    contrib: RenderingPluginContribution
  })], DOMInteractionPlugin);
  return DOMInteractionPlugin;
}();

export { DOMInteractionPlugin };